import { faqItems } from '../../../data/faq';

export default function Faq() {
  return (
    <section className="section faq" id="preguntas">
      <div className="container faq__layout">
        <div>
          <p className="eyebrow">Preguntas frecuentes</p>
          <h2 className="section-title">Todo lo que necesitas saber.</h2>
        </div>
        <div className="faq__list">
          {faqItems.map((item) => (
            <details key={item.question}>
              <summary>{item.question}<span aria-hidden="true">+</span></summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
